import styled from "styled-components";

export const InputDiv = styled.div`
  width: auto;
  height: 40px;
  border: 2px solid #292d32a4;
  border-radius: 6px;
  display: flex;
  overflow:hidden;

  &:focus-within {
    border: 2px solid black;
  }

  @media (max-width: 728px) {
    height: 40px;
  }

  div:first-child {
    width: 55px;
    height: 30px;
    border-right: 2px solid #292d32a4;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: 728px) {
      width: 55px;
      height: 30px;
    }
  }

  div:nth-child(2) {
    width: 83%;
    height: 30px;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: 728px) {
      height: 30px;
    }

    input {
      width: calc(99% - 4%);
      height: 90%;
      border: none;
      outline: none;

      @media (max-width: 728px) {
        font-size: 18px;
      }
    }
  }
  div:nth-child(3) {
    height: 100%;

    button {
      padding: 10px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;
